/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Shadow_Opacity_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Shadow Opacity" |
*
* @param {Styles_Shadow_Opacity_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_shadow_opacity_aria_label = /** @type {((inputs?: Styles_Shadow_Opacity_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Shadow_Opacity_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Opacite d'ombre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schattendeckkraft")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opacità dell'ombra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Прозрачность тени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opacidad de la sombra")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("阴影不透明度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("影の不透明度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("छाया अपारदर्शिता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opacidade da sombra")
	return /** @type {LocalizedString} */ ("Shadow Opacity")
});